import React, { useRef, useState } from "react";
import "./deleteTemplate.css";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { api } from "../../../../../../utility/AxiosInceptor";
import CommonLoaderBlue from "../../../../../components/Loader/LoaderBlue";
export default function DeleteTemplate({
  setRefreshTemplateData,
  currentSelectedRow,
  setCurrentActiveScreen,
  setSelectedAction,
  cpData,
  currentInvoice,
  setCurrentActiveDialog,
}) {
  let toast = useRef();
  const [isLoading, setIsLoading] = useState(false);
  function handleDeleteTemplate() {
    setIsLoading(true);
    api
      .delete(
        `/api/web/reportDownload/delete-template?id=${currentSelectedRow._id}`,
      )
      .then((response) => {
        toast.current.show({
          severity: "success",
          summary: "Delete Report",
          detail:
            response?.data?.message ||
            response?.data?.msg ||
            "Report Deleted Successfully",
        });

        setTimeout(() => {
          setRefreshTemplateData((prev) => !prev);
          setCurrentActiveScreen((prev) => ({
            ...prev,
            isDelete: false,
            isEdit: false,
            isDownload: false,
          }));
        }, 500);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.current.show({
          severity: "error",
          summary: "Delete Report",
          detail: error?.response?.data?.message || "Report Deleting Failed",
        });
      });
  }

  return (
    <>
      <div
        style={{
          position: "fixed",
          zIndex: 9999,
          width: "100vw",
          height: "100vh",
          backgroundColor: "#FFFFFF99",
          top: 0,
          left: 0,
        }}
      ></div>
      <form
        id="invoice-download-main"
        className="invoice-download-main flex flex-wrap flex-row justify-content-center"
      >
        <div className="main-download-invoice">
          <div className="top-header-downloadinvoice">
            <h1>Delete Template</h1>
            <p>
              Are you sure you want to permanently delete{" "}
              <span style={{ fontWeight: "700", fontSize: "1.6rem" }}>
                '{currentSelectedRow.reportName}'
              </span>
              ? This action cannot be undone.
            </p>
          </div>
          <div className="action-buttons flex flex-wrap flex-row justify-content-between aligbn-item-center">
            <Button
              type="button"
              disabled={isLoading}
              onClick={() => {
                setTimeout(() => {
                  setCurrentActiveScreen((prev) => ({
                    ...prev,
                    isDelete: false,
                    isEdit: false,
                    isDownload: false,
                  }));
                }, 500);
              }}
              label="Cancel"
            />
            <Button
              type="button"
              disabled={isLoading}
              onClick={handleDeleteTemplate}
              label={
                isLoading ? (
                  <div className="flex flex-wrap flex-row justify-content-center align-items-center">
                    <CommonLoaderBlue sizehere="12" color="white" />{" "}
                  </div>
                ) : (
                  "Delete"
                )
              }
            />
          </div>
        </div>
        <Toast ref={toast} />
      </form>
    </>
  );
}
